export const PaymentMethodAvailability = {
    IpsOnly: "IpsOnly",
    IpsAndDealer: "IpsAndDealer"
}

export const paymentMethodAvailabilityOptions = [
    { text: "Available to IPS only", value: PaymentMethodAvailability.IpsOnly },
    { text: "Available to IPS & Supplier Admin", value: PaymentMethodAvailability.IpsAndDealer }
];
